import { PATH_NAME_PARTNER_TVING_CONNECTION } from '@/common/resources/router.const'

export default [
  {
    // 티빙 X 웨이브 결합 상품 연동을 위한 라우트
    path: '/partner/tving/connection',
    name: PATH_NAME_PARTNER_TVING_CONNECTION,
    components: {
      partnerConnection: () => import('@/pages/partner/tving/connection'),
    },
  },
]
